export default __webpack_public_path__ + "static/media/fondo_usability.d4e95760.png";